export function getInitials(full_name: string): string {
  const nameParts = full_name.split(" ");
  const firstName = nameParts[0];
  const lastName = nameParts[nameParts.length - 1];
  // console.log()
  return `${firstName.charAt(0)}${lastName.charAt(0)}`;
}
